export const GET_EQUIPMENT_BY_ID = 'GET_EQUIPMENT_BY_ID';
export const SET_EQUIPMENTS = 'SET_EQUIPMENTS';

export default GET_EQUIPMENT_BY_ID;
